export default "__VITE_ASSET__f76d547d__"